/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React base styles
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";
import { figmaTokens } from "assets/theme/designTokens";

const { borderRadius } = borders;
const { sm } = boxShadows;

const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: figmaTokens.surface,
      boxShadow: sm,
      borderRadius: borderRadius.lg,
      border: `1px solid ${figmaTokens.borderSubtle}`,
    },
  },
};

export default tableContainer;
